import { render } from "./StartLayout.vue?vue&type=template&id=23c1346a"
import script from "./StartLayout.vue?vue&type=script&lang=js"
export * from "./StartLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__